"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhoneMain;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Phone = _interopRequireDefault(require("./Phone"));
var _PhoneWithHint = _interopRequireDefault(require("./PhoneWithHint"));
var _styles = _interopRequireDefault(require("./styles"));
function PhoneMain(props) {
  const classes = (0, _styles.default)(props);
  const {
    phone = "8 800 100-10-20",
    phoneHint = "Для звонков по России (бесплатно)",
    phones
  } = props;
  const phonesArr = phones || [phone];
  const isSinglePhone = phonesArr.length === 1;
  const phoneWithHintProps = {
    phone: phonesArr[0],
    phoneHint,
    classes: {
      phoneHint: classes.phoneHint,
      phoneNum: classes.phoneNum
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.phoneContainer, {
      [classes.phoneContainerAB]: props.ABphone
    })
  }, isSinglePhone ? /*#__PURE__*/_react.default.createElement(_PhoneWithHint.default, phoneWithHintProps) : phonesArr.map((phone1, i) => /*#__PURE__*/_react.default.createElement(_Phone.default, {
    key: i,
    number: phone1,
    classes: {
      phoneNum: classes.phoneMultiple
    }
  })));
}